'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './toc_policy.routes';

export class TocPolicyComponent {
  /*@ngInject*/
  constructor($scope, navService) {
    this.$scope = $scope;
    this.navService = navService;
  }

  $onInit(){


  }
}

export default angular.module('appApp.toc_policy', [uiRouter])
  .config(routes)
  .component('tocPolicy', {
    template: require('./toc_policy.html'),
    controller: TocPolicyComponent,
    controllerAs: 'tocPolicyCtrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/account/toc_policy/toc_policy.component.js